import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 報表api
 */
class reportApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
      * 匯出入會費、報聘費excel
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    exportJoinFee(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_EXPORT_JOIN_FEE}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
      * 取得每月新增人數
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMonthAdd(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MONTH_ADD}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得每月身故理賠人數
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMonthPay(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MONTH_PAY}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得每月統計
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMonthStatistical(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MONTH_STATISTICAL}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }


    /**
      * 匯出每月人數excel
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    exportReportMonth(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_EXPORT_REPORT_MONTH}`,
          params: params,
          is_loading: true,
          responseType: "blob",
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得每月繳滿人數
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMonthPayOff(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MONTH_PAY_OFF}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得契約各組相關數據總表
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportAllMember(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_ALL_MEMBER}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得帳單相關數據總表
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportAllBill(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_ALL_BILL}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得每月件數一覽
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMonthMember(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MONTH_MEMBER}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得互助人年齡層
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMemberAge(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MEMBER_AGE}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得業務年齡層
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportSalesAge(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_SALES_AGE}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得失效會員繳款次數
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportMemberExclusionPaycount(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_MEMBER_EXCLUSION_PAYCOUNT}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 取得身故會員理賠分布
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getReportClaimMember(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_REPORT_CLAIM_MEMBER}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }
}

export default reportApi;



// WEBPACK FOOTER //
// ./src/models/API/reportApi.js